import { Button } from "@/components/button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "@/components/dialog";
import { Modal } from "@/components/modal";

interface DeleteConfirmationModalProps {
  isLoading?: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteConfirmationModal({
  isLoading = false,
  isOpen,
  onCancel,
  onConfirm,
}: DeleteConfirmationModalProps) {
  return (
    <Modal isOpen={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <Dialog>
        <DialogHeader>
          <h2 className="text-lg font-semibold text-text-primary">
            Delete Message
          </h2>
        </DialogHeader>

        <DialogBody>
          <p className="text-sm text-text-secondary">
            Are you sure you want to delete this message? This action cannot be
            undone.
          </p>
        </DialogBody>

        <DialogFooter>
          <Button
            color="gray"
            isDisabled={isLoading}
            onPress={onCancel}
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            color="destructive"
            isDisabled={isLoading}
            isLoading={isLoading}
            onPress={onConfirm}
            variant="primary"
          >
            {isLoading ? "Deleting..." : "Delete"}
          </Button>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
